export const isWebView = () => {
	if (window.ReactNativeWebView && typeof window.ReactNativeWebView.postMessage === 'function') {
		return true;
	}

	const userAgent = navigator.userAgent || navigator.vendor || window.opera;

	const isReactNativeWebView =
		userAgent.includes('ReactNativeWebView') ||
		userAgent.includes('PritMobileApp') ||
		window.ReactNativeWebView !== undefined ||
		(window.postMessage !== undefined && window.postMessage.length !== 1);

	const isIOSWebView =
		/iPhone|iPod|iPad/i.test(userAgent) && (
			!/Safari/i.test(userAgent) ||
			(userAgent.includes('AppleWebKit') && !userAgent.includes('CriOS') && !userAgent.includes('FxiOS')) ||
			(window.webkit && window.webkit.messageHandlers !== undefined)
		);

	const isAndroidWebView =
		(/Android/i.test(userAgent) &&
		/wv|Version\/[\d.]+/i.test(userAgent));

	return isReactNativeWebView || isIOSWebView || isAndroidWebView;
};

export const isIOSWebView = () => {
	const userAgent = navigator.userAgent || '';
	return /iPhone|iPod|iPad/i.test(userAgent) && isWebView();
};

export const isAndroidWebView = () => {
	const userAgent = navigator.userAgent || '';
	return /Android/i.test(userAgent) && isWebView();
};

export const sendToReactNative = (type, data) => {
	const message = JSON.stringify({ type, data });

	try {
		if (window.ReactNativeWebView && window.ReactNativeWebView.postMessage) {
			window.ReactNativeWebView.postMessage(message);
			return true;
		}

		if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.ReactNative) {
			window.webkit.messageHandlers.ReactNative.postMessage(message);
			return true;
		}

		if (window.Android && window.Android.postMessage) {
			window.Android.postMessage(message);
			return true;
		}

		if (window.postMessage) {
			window.postMessage(message, '*');
			return true;
		}
	} catch (error) {
		return false;
	}

	return false;
};

export const listenToReactNative = (callback) => {
	const handleMessage = (event) => {
		try {
			let data;
			if (typeof event.data === 'string') {
				data = JSON.parse(event.data);
			} else {
				data = event.data;
			}

			callback(data);
		} catch (error) {
			void error;
		}
	};

	window.addEventListener('message', handleMessage);
	document.addEventListener('message', handleMessage);

	return () => {
		window.removeEventListener('message', handleMessage);
		document.removeEventListener('message', handleMessage);
	};
};

export const getWebViewInfo = () => {
	return {
		isWebView: isWebView(),
		userAgent: navigator.userAgent,
		platform: navigator.platform,
		vendor: navigator.vendor,
		hasReactNativeWebView: window.ReactNativeWebView !== undefined,
		hasWebkitHandlers: window.webkit && window.webkit.messageHandlers !== undefined,
		hasAndroidInterface: window.Android !== undefined,
	};
};